
import { Button } from "@/components/ui/button";
import { Edit2 } from "lucide-react";
import { useLanguage } from "@/contexts/language";
import { t } from "@/utils/translations";

interface EditButtonProps {
  onClick: () => void;
}

const EditButton = ({ onClick }: EditButtonProps) => {
  const { language } = useLanguage();
  
  return (
    <Button variant="ghost" size="icon" className="h-8 w-8" onClick={onClick}>
      <Edit2 className="h-4 w-4" />
      <span className="sr-only">
        {t('common.editEntry', language)}
      </span>
    </Button>
  );
};

export default EditButton;
